import React, { Fragment } from "react";
import { withStyles } from "@material-ui/core";
import DataGrid from '@dataGrid';
import styles from "../../styles";
import GridConfig from "./gridConfig";
import { getDataWithQueryString, postData} from "../../../../../api/componentAPIs";
import { compose } from "recompose";
import { withSnackbar } from 'notistack';
import { withUserProfile } from "../../../../../userProfile/userProfileContext";
import MESSAGES from "../../../../../appMessages";
import Events from "../../../../../utilities/EventEmitter";
import { withAppConfig } from "../../../../../appConfigContext";

class KPIGoals extends React.Component {
    constructor(props){
        super(props);
        this.gridConfig = new GridConfig();
        this.state= {
            terminalID : 1,
            kpiData: null,
            errorMessage: null
        }
        this._isComponentMounted = false;
    }

    componentDidMount(){
        this._isComponentMounted = true;
        this.getKPIGoalData();
    }

    componentWillUnmount(){
        this._isComponentMounted = false;
    }

    componentDidUpdate(prevProps){
        if(this.props.userData.userProfile.terminal.id !== prevProps.userData.userProfile.terminal.id){
            this.getKPIGoalData();
        }
    }

    onGridReady = ({api}) => {
        this.gridApi = api;
    }

    getKPIGoalData = () => {
        getDataWithQueryString("GetTerminalKPIGoals", `terminalId=${this.props.userData.userProfile.terminal.id}`).then(
            response =>{
                if(this._isComponentMounted){
                    if(response && response.status >= 200 && response.status < 400){
                        this.setState({
                            kpiData: response.data,
                            errorMessage: null
                        });
                    }else{
                        this.setState({
                            kpiData: null,
                            errorMessage: MESSAGES.COMMON.GRID_DATA_FETCH_FAILED
                        });
                        this.props.enqueueSnackbar(MESSAGES.KPI.FETCH_DATA_FAILURE, {variant: "error"});
                    }
                }
            },
            error => {
                if(this._isComponentMounted){
                    this.setState({
                        kpiData: null,
                        errorMessage: MESSAGES.COMMON.GRID_DATA_FETCH_FAILED
                    });
                    this.props.enqueueSnackbar(MESSAGES.KPI.FETCH_DATA_FAILURE, {variant: "error"});
                }

            }
        )
    }

    onCellValueChanged = (params) => {
        if(params.colDef.field === "kpiValue" && params.oldValue !== params.newValue){
            if(params.newValue === ""){
                this.props.enqueueSnackbar(`${params.data.displayName} goal cannot be empty`, {variant: "error"});
                params.data[params.colDef.field] = params.oldValue;
                this.gridApi.refreshCells();
            } else {
                this.updateKPIGoalsData(params);
            }

        }
    }

    updateKPIGoalsData = (params) => {
        const requestParams = {
            terminalId: this.props.userData.userProfile.terminal.id,
            [params.data.kpiName]:params.data.kpiValue
        }

        postData("UpdateTerminalKPIGoals", requestParams).then(response =>{
            if(response && Math.trunc(response.status/100) === 2){
                this.props.enqueueSnackbar(`Updated ${params.data.displayName} goal`, {variant: "success"});
                Events.emit("RefreshKPI");
                return;
            }
            this.handleError(params, response.status);
        }, () => {
            this.handleError(params);
        })
    }

    handleError = (params, statusCode) => {
        params.data[params.colDef.field] = params.oldValue;
        this.gridApi.refreshCells();
        if (statusCode === 403) {
            return;
        }
        this.props.enqueueSnackbar(`Failed to update ${params.data.displayName} goal`, {variant: "error"});
    }


    render(){
        const { classes } = this.props;
        return (
            <Fragment>
                <header className={classes.moduleHeader}  data-automationid="kpiGoals-title"> KPI Goals </header>
                <div className={classes.moduleContainer}>
                    <div className={classes.moduleMessage}>
                        {`This is the list of KPI goals you can set for each ${this.props.configJSON.terminalAccessLabel.fullName.toLowerCase()}.`}
                    </div>
                    <div className={`${classes.gridContainer} ${classes.KPIGoalGridContainer}`}>
                        <div className={`${classes.dataGrid} ${classes.dataGridKpi}`}>
                           {!this.state.errorMessage ? (
                            <DataGrid
                                columnDefs={this.gridConfig.config.columns}
                                config={this.gridConfig.config}
                                defaultColDef={this.gridConfig.config.defaultColDef}
                                enableFilter={this.gridConfig.config.enableFilter}
                                rowData={this.state.kpiData}
                                onGridReady={this.onGridReady}
                                onCellValueChanged={this.onCellValueChanged}
                                getRowId={(params) => params.data.kpiName}
                            />
                               ): (
                                <div className={classes.errorMessageContainer}>
                                        <div className={classes.errorMessage}> {this.state.errorMessage} </div>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </Fragment>
        )
    }
}
export default compose(withStyles(styles), withUserProfile, withSnackbar, withAppConfig)(KPIGoals)